/** Conversational call log flow for the terminal assistant. */
import { todayISO, nowTime } from './utils.js';
import {
  DATE_HINT,
  TIME_HINT,
  parseSmartDate,
  validateSmartDate,
  isSkip,
} from './assistant-datetime.js';
import { parseSmartTime } from './assistant-ticket-new.js';

export function parseCallVia(raw) {
  const s = String(raw || '').trim().toLowerCase();
  if (s === '1' || s.includes('whatsapp') || s === 'wa') return 'WhatsApp';
  if (s === '2' || s.includes('phone') || s === 'call') return 'Phone';
  return null;
}

export function callLogSteps() {
  return [
    {
      key: 'call_date',
      ask: 'Call date?',
      hint: `${DATE_HINT} · enter for today (${todayISO()})`,
      default: () => todayISO(),
      validate: (v) => {
        if (!String(v).trim()) return null;
        return validateSmartDate(v);
      },
      parse: (v) => parseSmartDate(v) || todayISO(),
    },
    {
      key: 'call_time',
      ask: 'Call time?',
      hint: `${TIME_HINT} · enter for now (${nowTime()})`,
      default: () => nowTime(),
      validate: (v) => {
        if (!String(v).trim()) return null;
        if (!parseSmartTime(v)) return `Invalid time. Use ${TIME_HINT}.`;
        return null;
      },
      parse: (v) => parseSmartTime(v) || nowTime(),
    },
    {
      key: 'call_via',
      ask: 'Call via?',
      hint: '  1 WhatsApp · 2 Phone',
      validate: (v) => (!parseCallVia(v) ? 'Pick 1 (WhatsApp) or 2 (Phone).' : null),
      parse: (v) => parseCallVia(v),
    },
    {
      key: 'discussion',
      ask: 'Discussion details?',
      hint: 'What was discussed with the client',
      validate: (v) => (!String(v).trim() || isSkip(v) ? 'Enter discussion details.' : null),
      parse: (v) => String(v).trim(),
    },
  ];
}

export function buildCallLogBody(answers = {}) {
  return {
    call_date: answers.call_date || todayISO(),
    call_time: answers.call_time || nowTime(),
    notes: answers.discussion,
    response: answers.call_via,
  };
}

export function validateCallLogAnswers(answers = {}) {
  if (!answers.discussion) return 'Enter discussion details.';
  if (!answers.call_via) return 'Pick call channel: 1 WhatsApp · 2 Phone';
  return null;
}
